import { render, staticRenderFns } from "./CalendarMarketing.vue?vue&type=template&id=c5785942"
import script from "./CalendarMarketing.vue?vue&type=script&lang=js"
export * from "./CalendarMarketing.vue?vue&type=script&lang=js"
import style0 from "./CalendarMarketing.vue?vue&type=style&index=0&id=c5785942&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports